import { Content } from 'interface/content/content.interface';
import { ContentActionTypes } from './content.type';

export function setContentInstances(payload: { contentInstances: Content[] }) {
  return {
    type: ContentActionTypes.SET_CONTENT_INSTANCES,
    payload,
  };
}
